// CardOrders.jsx (CSS inclus + classes uniques : cardorders-*)
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiShoppingCart, FiEye, FiHeart, FiStar } from "react-icons/fi";
import { MdLocalOffer } from "react-icons/md";
import ShowimagesLoading from "./showImagesLoading";
import Price from "../pageInside/productsPrice";
import { elakayAutoText } from "./dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["cardOrders"]?.[key] || fallback;

const CardOrders = ({
  laguangeElakay,
  infoSource,
  product,
  classCardOrders0 = "col p-0",
  classCardOrders1 = "card",
  urlImg,
  key,
  orderURL = false,
  showAddToCart = false,
  onAddToCart,
  discount,
  rating,
  reviews,
  isNew = false,
  isFeatured = false,
}) => {
  __setElakayInfoSource(infoSource);
  const translatedText = (section, key, fallback) =>
    infoSource?.laguangeElakay?.(section, infoSource?.languageAPI)?.[key]
    || (typeof laguangeElakay === "function" ? laguangeElakay(section, infoSource?.languageAPI)?.[key] : null)
    || fallback;
  const [isHovered, setIsHovered] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);

  const nameImg = product.name ? product.name : "elakay image";
  const productName = product.name || "Product Name";

  const displayName = productName.length > 45 ? productName.substring(0, 45) + "..." : productName;

  const handleFavoriteClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsFavorite(!isFavorite);
  };

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onAddToCart) onAddToCart(product);
  };

  return (
    <>
      <style>{`
        /* ========================================
           CARDORDERS - ULTRA PROFESSIONAL DESIGN
           classes uniques: cardorders-*
           ======================================== */

        :root{
          --cardorders-card-bg:#ffffff;
          --cardorders-card-border:#e2e8f0;
          --cardorders-card-shadow:rgba(0,0,0,0.08);
          --cardorders-card-shadow-hover:rgba(0,0,0,0.15);

          --cardorders-primary:#4facfe;
          --cardorders-primary-dark:#0ea5e9;
          --cardorders-accent:#667eea;

          --cardorders-text:#1e293b;
          --cardorders-text-light:#64748b;
          --cardorders-text-lighter:#94a3b8;

          --cardorders-badge-discount:#ef4444;
          --cardorders-badge-new:#10b981;
          --cardorders-badge-featured:#f59e0b;

          --cardorders-action-hover:#f8fafc;
          --cardorders-action-active:#4facfe;

          --cardorders-transition:cubic-bezier(0.4,0,0.2,1);
        }

        /* ========================================
           CARD CONTAINER
           ======================================== */
        .cardorders-product-card{
          position:relative;
          background:var(--cardorders-card-bg);
          border-radius:16px;
          border:1px solid var(--cardorders-card-border);
          overflow:hidden;
          transition:all 0.4s var(--cardorders-transition);
          box-shadow:0 2px 8px var(--cardorders-card-shadow), 0 0 0 1px rgba(0,0,0,0.02);
          cursor:pointer;
          height:100%;
          display:flex;
          flex-direction:column;
        }

        .cardorders-product-card:hover{
          transform:translateY(-8px) scale(1.02);
          box-shadow:0 12px 40px var(--cardorders-card-shadow-hover), 0 0 0 1px rgba(79,172,254,0.1);
          border-color:rgba(79,172,254,0.3);
        }

        /* ========================================
           IMAGE CONTAINER
           ======================================== */
        .cardorders-product-image-container{
          position:relative;
          width:100%;
          padding-top:100%;
          overflow:hidden;
          background:linear-gradient(135deg,#f8fafc 0%,#f1f5f9 100%);
          border-radius:16px 16px 0 0;
        }

        .cardorders-product-image-wrapper{
          position:absolute;
          top:0; left:0;
          width:100%;
          height:100%;
          display:flex;
          align-items:center;
          justify-content:center;
          overflow:hidden;
        }

        .cardorders-product-image{
          width:100%;
          height:100%;
          object-fit:cover;
          transition:transform 0.6s var(--cardorders-transition);
        }

        .cardorders-product-card:hover .cardorders-product-image{
          transform:scale(1.1);
        }

        .cardorders-product-image-overlay{
          position:absolute;
          inset:0;
          background:linear-gradient(to bottom, transparent 0%, transparent 50%, rgba(0,0,0,0.6) 100%);
          opacity:0;
          transition:opacity 0.4s var(--cardorders-transition);
          pointer-events:none;
        }

        .cardorders-product-card:hover .cardorders-product-image-overlay{
          opacity:1;
        }

        /* ========================================
           BADGES
           ======================================== */
        .cardorders-product-badges{
          position:absolute;
          top:12px;
          left:12px;
          z-index:10;
          display:flex;
          flex-direction:column;
          gap:8px;
        }

        .cardorders-product-badge{
          display:inline-flex;
          align-items:center;
          gap:4px;
          padding:6px 12px;
          border-radius:8px;
          font-size:11px;
          font-weight:700;
          text-transform:uppercase;
          letter-spacing:0.5px;
          box-shadow:0 4px 12px rgba(0,0,0,0.15);
          backdrop-filter:blur(10px);
          animation:cardorders-badgeSlideIn 0.5s var(--cardorders-transition) backwards;
        }

        @keyframes cardorders-badgeSlideIn{
          from{opacity:0; transform:translateX(-20px);}
          to{opacity:1; transform:translateX(0);}
        }

        .cardorders-badge-discount{
          background:linear-gradient(135deg,var(--cardorders-badge-discount), #dc2626);
          color:#fff;
          animation-delay:0.1s;
        }

        .cardorders-badge-new{
          background:linear-gradient(135deg,var(--cardorders-badge-new), #059669);
          color:#fff;
          animation-delay:0.2s;
        }

        .cardorders-badge-featured{
          background:linear-gradient(135deg,var(--cardorders-badge-featured), #ea580c);
          color:#fff;
          animation-delay:0.3s;
        }

        .cardorders-badge-icon{
          font-size:12px;
        }

        .cardorders-badge-text{
          font-size:10px;
          line-height:1;
        }

        /* ========================================
           QUICK ACTIONS
           ======================================== */
        .cardorders-product-quick-actions{
          position:absolute;
          top:50%;
          left:50%;
          transform:translate(-50%, -50%);
          display:flex;
          gap:12px;
          z-index:20;
          opacity:0;
          visibility:hidden;
          transition:all 0.4s var(--cardorders-transition);
        }

        .cardorders-product-quick-actions-visible{
          opacity:1;
          visibility:visible;
        }

        .cardorders-quick-action-btn{
          width:48px;
          height:48px;
          background:rgba(255,255,255,0.95);
          backdrop-filter:blur(10px);
          border:1px solid rgba(79,172,254,0.2);
          border-radius:50%;
          display:flex;
          align-items:center;
          justify-content:center;
          font-size:20px;
          color:var(--cardorders-text);
          cursor:pointer;
          transition:all 0.3s var(--cardorders-transition);
          box-shadow:0 4px 12px rgba(0,0,0,0.15);
          text-decoration:none;
          animation:cardorders-actionBounceIn 0.5s var(--cardorders-transition) backwards;
        }

        @keyframes cardorders-actionBounceIn{
          0%{opacity:0; transform:scale(0);}
          50%{transform:scale(1.2);}
          100%{opacity:1; transform:scale(1);}
        }

        .cardorders-quick-action-btn:nth-child(1){animation-delay:0.1s;}
        .cardorders-quick-action-btn:nth-child(2){animation-delay:0.2s;}
        .cardorders-quick-action-btn:nth-child(3){animation-delay:0.3s;}

        .cardorders-quick-action-btn:hover{
          background:var(--cardorders-primary);
          color:#fff;
          transform:translateY(-4px) scale(1.1);
          box-shadow:0 8px 20px rgba(79,172,254,0.4);
        }

        .cardorders-quick-action-btn:active{
          transform:translateY(-2px) scale(1.05);
        }

        .cardorders-quick-action-btn-favorite-active{
          background:var(--cardorders-badge-discount);
          color:#fff;
        }

        .cardorders-quick-action-btn-favorite-active svg{
          fill:#fff;
        }

        .cardorders-quick-action-btn-view:hover{
          background:var(--cardorders-accent);
        }

        .cardorders-quick-action-btn-cart:hover{
          background:var(--cardorders-badge-new);
        }

        .cardorders-heart-filled{
          fill:#fff;
        }

        /* ========================================
           CARD BODY
           ======================================== */
        .cardorders-product-card-body{
          padding:20px;
          display:flex;
          flex-direction:column;
          gap:12px;
          flex:1;
          background:var(--cardorders-card-bg);
          position:relative;
          z-index:5;
        }

        /* PRODUCT NAME */
        .cardorders-product-name{
          font-size:15px;
          font-weight:600;
          color:var(--cardorders-text);
          margin:0;
          line-height:1.4;
          display:-webkit-box;
          -webkit-line-clamp:2;
          -webkit-box-orient:vertical;
          overflow:hidden;
          min-height:42px;
          transition:color 0.3s ease;
        }

        .cardorders-product-card:hover .cardorders-product-name{
          color:var(--cardorders-primary);
        }

        /* RATING */
        .cardorders-product-rating{
          display:flex;
          align-items:center;
          gap:8px;
          margin-top:-4px;
        }

        .cardorders-rating-stars{
          display:flex;
          gap:2px;
        }

        .cardorders-star{
          font-size:14px;
          color:#cbd5e1;
          transition:all 0.3s ease;
        }

        .cardorders-star-filled{
          color:#fbbf24;
          fill:#fbbf24;
        }

        .cardorders-rating-count{
          font-size:12px;
          color:var(--cardorders-text-light);
          font-weight:500;
        }

        /* FOOTER */
        .cardorders-product-footer{
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap:12px;
          margin-top:auto;
          padding-top:12px;
          border-top:1px solid #f1f5f9;
        }

        .cardorders-product-price-wrapper{
          flex:1;
        }

        /* VIEW LINK */
        .cardorders-product-view-link{
          display:inline-flex;
          align-items:center;
          gap:6px;
          padding:8px 16px;
          background:linear-gradient(135deg,var(--cardorders-primary), var(--cardorders-primary-dark));
          color:#fff;
          font-size:13px;
          font-weight:600;
          border-radius:8px;
          text-decoration:none;
          transition:all 0.3s var(--cardorders-transition);
          box-shadow:0 2px 8px rgba(79,172,254,0.3);
          white-space:nowrap;
        }

        .cardorders-product-view-link:hover{
          transform:translateY(-2px);
          box-shadow:0 6px 16px rgba(79,172,254,0.5);
          color:#fff;
        }

        .cardorders-product-view-link:active{
          transform:translateY(0);
        }

        .cardorders-view-icon{
          font-size:16px;
          transition:transform 0.3s ease;
        }

        .cardorders-product-view-link:hover .cardorders-view-icon{
          transform:translateX(3px);
        }

        /* SHINE */
        .cardorders-product-shine{
          position:absolute;
          top:0;
          left:-100%;
          width:50%;
          height:100%;
          background:linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.3) 50%, transparent 100%);
          transform:skewX(-20deg);
          transition:left 0.6s ease;
          pointer-events:none;
          z-index:30;
        }

        .cardorders-product-card:hover .cardorders-product-shine{
          left:150%;
        }

        /* RESPONSIVE */
        @media (max-width:768px){
          .cardorders-product-card{border-radius:12px;}
          .cardorders-product-image-container{border-radius:12px 12px 0 0;}
          .cardorders-product-card-body{padding:16px;}
          .cardorders-product-name{font-size:14px; min-height:40px;}
          .cardorders-product-badges{top:8px; left:8px; gap:6px;}
          .cardorders-product-badge{padding:4px 8px; font-size:9px;}
          .cardorders-badge-icon{font-size:10px;}
          .cardorders-quick-action-btn{width:40px; height:40px; font-size:18px;}
          .cardorders-product-footer{flex-direction:column; align-items:flex-start; gap:8px;}
          .cardorders-product-view-link{width:100%; justify-content:center; padding:10px 16px;}
        }

        @media (max-width:480px){
          .cardorders-product-card{border-radius:10px;}
          .cardorders-product-card:hover{transform:translateY(-4px) scale(1.01);}
          .cardorders-product-card-body{padding:12px; gap:8px;}
          .cardorders-product-name{font-size:13px; min-height:36px; -webkit-line-clamp:2;}
          .cardorders-rating-stars .cardorders-star{font-size:12px;}
          .cardorders-rating-count{font-size:11px;}
          .cardorders-product-footer{padding-top:8px;}
          .cardorders-product-quick-actions{gap:8px;}
          .cardorders-quick-action-btn{width:36px; height:36px; font-size:16px;}
        }

        /* ACCESSIBILITY */
        .cardorders-product-card:focus-within{
          outline:3px solid var(--cardorders-primary);
          outline-offset:2px;
        }

        .cardorders-quick-action-btn:focus-visible,
        .cardorders-product-view-link:focus-visible{
          outline:3px solid var(--cardorders-primary);
          outline-offset:2px;
          border-radius:inherit;
        }

        @media (prefers-reduced-motion: reduce){
          *, *::before, *::after{
            animation-duration:0.01ms !important;
            animation-iteration-count:1 !important;
            transition-duration:0.01ms !important;
          }
          .cardorders-product-card:hover{
            transform:none !important;
          }
        }

        /* PRINT */
        @media print{
          .cardorders-product-card{
            break-inside:avoid;
            box-shadow:none;
            border:1px solid #ddd;
          }
          .cardorders-product-quick-actions,
          .cardorders-product-shine,
          .cardorders-product-image-overlay{
            display:none !important;
          }
        }
      `}</style>

      <div key={key} className={classCardOrders0}>
        <div
          className={`cardorders-product-card ${classCardOrders1} ${isHovered ? "cardorders-hovered" : ""}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {/* Image Container */}
          <div className="cardorders-product-image-container">
            {/* Badges */}
            <div className="cardorders-product-badges">
              {discount && (
                <div className="cardorders-product-badge cardorders-badge-discount">
                  <MdLocalOffer className="cardorders-badge-icon" />
                  <span className="cardorders-badge-text">{discount}{__elakayText("t005", "% OFF")}</span>
                </div>
              )}

              {isNew && (
                <div className="cardorders-product-badge cardorders-badge-new">
                  <span className="cardorders-badge-text">{elakayAutoText("h_66aabd91fc41cc", "NEW")}</span>
                </div>
              )}

              {isFeatured && (
                <div className="cardorders-product-badge cardorders-badge-featured">
                  <FiStar className="cardorders-badge-icon" />
                  <span className="cardorders-badge-text">{infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource?.languageAPI)?.cardOrders?.t001 || __elakayText("t001", "Discount")}</span>
                </div>
              )}
            </div>

            {/* Image */}
            <div className="cardorders-product-image-wrapper">
              <ShowimagesLoading src={urlImg} alt={nameImg} className="cardorders-product-image" width={120} />
              <div className="cardorders-product-image-overlay"></div>
            </div>

            {/* Quick Actions */}
            <div
              className={`cardorders-product-quick-actions ${
                isHovered ? "cardorders-product-quick-actions-visible" : ""
              }`}
            >
              <button
                className={`cardorders-quick-action-btn ${
                  isFavorite ? "cardorders-quick-action-btn-favorite-active" : ""
                }`}
                onClick={handleFavoriteClick}
                aria-label={infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource?.languageAPI)?.cardOrders?.t002 || __elakayText("t002", "Favorite")}
              >
                <FiHeart className={isFavorite ? "cardorders-heart-filled" : ""} />
              </button>

              {orderURL && (
                <Link to={orderURL} className="cardorders-quick-action-btn cardorders-quick-action-btn-view" aria-label={infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource?.languageAPI)?.cardOrders?.t003 || __elakayText("t003", "View") }>
                  <FiEye />
                </Link>
              )}

              {showAddToCart && (
                <button
                  className="cardorders-quick-action-btn cardorders-quick-action-btn-cart"
                  onClick={handleAddToCart}
                  aria-label={infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource?.languageAPI)?.cardOrders?.t004 || __elakayText("t004", "Add to cart")}
                >
                  <FiShoppingCart />
                </button>
              )}
            </div>
          </div>

          {/* Body */}
          <div className="cardorders-product-card-body">
            <h3 className="cardorders-product-name" title={productName}>
              {displayName}
            </h3>

            {rating && (
              <div className="cardorders-product-rating">
                <div className="cardorders-rating-stars">
                  {[...Array(5)].map((_, i) => (
                    <FiStar
                      key={i}
                      className={`cardorders-star ${i < Math.floor(rating) ? "cardorders-star-filled" : ""}`}
                    />
                  ))}
                </div>
                {reviews && <span className="cardorders-rating-count">({reviews})</span>}
              </div>
            )}

            <div className="cardorders-product-footer">
              <div className="cardorders-product-price-wrapper">
                <Price showAddToCartButton={false} products={product} />
              </div>

              {orderURL && (
                <Link to={orderURL} className="cardorders-product-view-link">
                  <span>{translatedText("label", "view", "View")}</span>
                  <FiEye className="cardorders-view-icon" />
                </Link>
              )}
            </div>
          </div>

          {/* Shine */}
          <div className="cardorders-product-shine"></div>
        </div>
      </div>
    </>
  );
};

export default CardOrders;
